module.exports = "https://cdn2-fs.clearscore.com/flux/images/11f2a84b5cdef0763a0863b1fe800738.jpg";